import { createFileRoute } from '@tanstack/react-router';
import { TimelineTab, validateTimelineSearch } from '@/features/shipment-detail/timeline/timeline-tab';

// S03 · Timeline (07 §3). Filters in the URL: ?kind=facts&container=…&source=…
export const Route = createFileRoute('/_app/shipments/$id/timeline')({
  validateSearch: validateTimelineSearch,
  component: TimelineTab,
});
